const TypeHolidayEnum = [
    {
        label: "Municipal",
        value: "M",
    },
    {
        label: "Nacional",
        value: "N",
    },
    {
        label: "Recesso",
        value: "R",
    },
];

const getAll = () => {
    return TypeHolidayEnum;
};

const getByValue = (value: string) => {
    return TypeHolidayEnum.find((item) => item.value === value);
};

const getValue = (label: string) => {
    const result = TypeHolidayEnum.find((item) => item.label === label);
    return result?.value || "";
};

const getLabel = (value: string) => {
    const result = TypeHolidayEnum.find((item) => item.value === value);
    return result?.label || "";
};

export default { getAll, getByValue, getValue, getLabel };
